import { connect } from 'react-redux';

import PropTypes from 'prop-types';
import { getFormValues } from 'redux-form';

import CourierErrorFormComponent from './CourierErrorFormComponent';

import { onModalClose } from '../Modal/actions';
import { createCourierError } from './actions';

const form = 'courierError';

const CourierErrorFormContainer = (props) => {
  const { onCreateCourierError, onModalClose, formValues, call_sid } = props;

  const onCourierErrorSubmit = () => {
    onCreateCourierError(
      Object.assign(formValues, {
        call_sid,
      }),
    );
    onModalClose();
  };

  return (
    <CourierErrorFormComponent
      form={form}
      onCourierErrorSubmit={onCourierErrorSubmit}
    />
  );
};

CourierErrorFormContainer.defaultProps = {
  formValues: {},
  call_sid: '',
};

CourierErrorFormContainer.propTypes = {
  onCreateCourierError: PropTypes.func.isRequired,
  onModalClose: PropTypes.func.isRequired,
  formValues: PropTypes.instanceOf(Object),
  call_sid: PropTypes.string,
};

const mapStateToProps = (state) => ({
  formValues: getFormValues(form)(state) || {},
});

const mapDispatchToProps = (dispatch) => ({
  onCreateCourierError: (data) => createCourierError(dispatch, data),
  onModalClose: () => onModalClose(dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CourierErrorFormContainer);
